import { getOne, getRating, getShopsBetweenDates, SignUpService, updateOne, consumeS3Image, ConfirmSignup } from "../../Provider";

export async function GetUserInfoService(id) {
  return getOne(id);
}

export async function UserRegisterService(userInfo){
  return SignUpService(userInfo);
}

// "borrar" a un trabajador
export async function DeleteUserService(data){
  return updateOne(data);
}

export async function GetRatingDeliveryService(id){
  return getRating(id);
}

export async function GetShopsBetweenDatesService(data){
  return getShopsBetweenDates(data);
}

export async function GetPhotoProfileService(urlPhoto){
  const res = await consumeS3Image(urlPhoto);
  return res;
}

export async function ConfirmSignUpCodeService({id, code, data}){
  return  ConfirmSignup({id,code, data});
}